import classNames from "classnames";
import { CellProps } from "react-table";

import { IData } from "../../../types";

interface ModelColumnProps {
  modelType: string;
  modelVersion: string;
}

export const ModelColumn = ({ modelType, modelVersion }: ModelColumnProps) => {
  const modelClassName = classNames({
    "resp-badge": true,
    "resp-success":
      !modelType.includes("gpt-4") && !modelType.includes("gpt-3"),
    "resp-model-3": modelType.includes("gpt-3"),
    "resp-model-4": modelType.includes("gpt-4"),
  });

  return (
    <div className="d-flex w-auto align-content-md-start ">
      <div className={modelClassName}>
        {modelType}
        {modelVersion ? `-${modelVersion}` : ""}
      </div>
    </div>
  );
};
